import "leaflet/dist/leaflet.css";
import './App.css';
import "./styles.css";

import Dashboard from 'src/components/Dashboard/Dashboard';
import SignIn from 'src/components/Forms/SignIn';
import SignUp from 'src/components/Forms/SignUp';

import * as React from 'react';

import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';

import { getCurrentUser } from "src/services/auth"

// load w/ URL: https://codesandbox.io/s/geojson-sqtkl
// load from local: https://codesandbox.io/s/create-simple-map-highlight-regions-custom-colors-6cl66?file=/src/App.tsx
// great examples: https://codesandbox.io/examples/package/@types/react-leaflet [see "Find more" at bottom]

import { AxiosInterceptor } from 'src/services/instance'


function RequireAuth({ children }: { children: JSX.Element }) {
  let currentUser = getCurrentUser();
  if (currentUser == null) {
    // console.log("No user!");
    // console.log(localStorage.getItem("user"))
    // console.log(sessionStorage.getItem("user"));
    // console.log(localStorage.hasOwnProperty("remember"));
    // console.log(getCurrentUser());
    return <Navigate to="/login" replace />;
  }
  return children;
}

// have to set div width and height or ResponsiveContainer (recharts) won't work
// https://stackoverflow.com/questions/40541994/multiple-path-names-for-a-same-component-in-react-router
// https://www.robinwieruch.de/react-router-redirect/
//         <Route path="" element={<SignIn />} />
// https://stackoverflow.com/questions/69868956/how-to-redirect-in-react-router-v6
// https://stackoverflow.com/questions/70818978/maximum-update-depth-exceeded-from-navigate-component-react-router-dom-v6
function App() {

  return (
    // For local version, everything is under "app" now. For example, http://localhost:3000/app/login .
    // This seems fine, but we could skip the basename in development -- see constants.tsx
    < BrowserRouter basename="/app">
      <Routes>

        <Route
          path="/login"
          element={<SignIn />}
        />

        <Route
          path="/signup"
          element={<SignUp />}
        />

        <Route
          path="/dashboard"
          element={
            <RequireAuth>
              <AxiosInterceptor>
                <Dashboard />
              </AxiosInterceptor>
            </RequireAuth>
          }
        />

        <Route
          path="*"
          element={<Navigate to="/login" replace />}
        />

      </Routes>
    </BrowserRouter >
  );

}

export default App;
